/** Local mirror of the backend `crochetStrokeDefaults` user setting, so
 *  diagram creation can read it synchronously. Same contract as
 *  crochet-sizing-defaults.ts: server is the source of truth for signed-in
 *  users, refreshed on gallery mount (use-sync-crochet-stroke-defaults) and
 *  written through on settings Apply. */
import { sanitizeStrokeStyle, type StrokeStyle } from '@/crochet-editor/stroke-style';

const STORAGE_KEY = 'stitchpress-crochet-stroke-defaults';

type Listener = (s: StrokeStyle) => void;
const listeners = new Set<Listener>();

export function getCrochetStrokeDefaults(): StrokeStyle {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (raw == null) return {};
        return sanitizeStrokeStyle(JSON.parse(raw));
    } catch {
        return {};
    }
}

export function setCrochetStrokeDefaults(s: StrokeStyle): void {
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(s));
    } catch {
        // Ignore storage failures (private mode, etc.).
    }
    for (const l of listeners) l(s);
}

export function onCrochetStrokeDefaultsChange(listener: Listener): () => void {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
}
